"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayOfMonthOptions = exports.getWeekdayInfos = exports.getStartEndTimeMinuteInterval = exports.getDailyMinutesIntervalsForPaneType = exports.getHourlyMinutesIntervalsForPaneType = exports.localizeRecurrenceMinutes = exports.RecurrenceConverters = exports.RecurrenceDaysOfTheWeek = exports.NumberToRecurrencesMinutesMap = exports.RecurrenceMinutesToNumberMap = exports.RecurrenceMinutes = exports.RecurrenceType = exports.RecurrenceMode = exports.ONE_DAY = exports.TWELVE_HOURS = exports.EIGHT_HOURS = exports.SIX_HOURS = exports.FOUR_HOURS = exports.TWO_HOURS = exports.MINUTES_IN_HOUR = exports.HALF_HOUR = exports.FIFTEEN_MINUTES = void 0;
var Localize_1 = require("../../gen-src/Localize");
var MonthlyRecurrencePane_1 = require("./panes/MonthlyRecurrencePane");
var SelfServiceSchedulePane_1 = require("./SelfServiceSchedulePane");
var StaticInitializers_1 = require("./StaticInitializers");
exports.FIFTEEN_MINUTES = 15;
exports.HALF_HOUR = 30;
exports.MINUTES_IN_HOUR = 60;
exports.TWO_HOURS = 2 * exports.MINUTES_IN_HOUR;
exports.FOUR_HOURS = 4 * exports.MINUTES_IN_HOUR;
exports.SIX_HOURS = 6 * exports.MINUTES_IN_HOUR;
exports.EIGHT_HOURS = 8 * exports.MINUTES_IN_HOUR;
exports.TWELVE_HOURS = 12 * exports.MINUTES_IN_HOUR;
exports.ONE_DAY = 24 * exports.MINUTES_IN_HOUR;
var RecurrenceMode;
(function (RecurrenceMode) {
    RecurrenceMode["DataRefresh"] = "On Data Refresh";
    RecurrenceMode["TimeRecurrence"] = "Specified Time";
})(RecurrenceMode = exports.RecurrenceMode || (exports.RecurrenceMode = {}));
;
var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["Hourly"] = "Hourly";
    RecurrenceType["Daily"] = "Daily";
    RecurrenceType["Weekly"] = "Weekly";
    RecurrenceType["Monthly"] = "Monthly";
})(RecurrenceType = exports.RecurrenceType || (exports.RecurrenceType = {}));
;
var RecurrenceMinutes;
(function (RecurrenceMinutes) {
    RecurrenceMinutes["FifteenMinutes"] = "FifteenMinutes";
    RecurrenceMinutes["HalfHour"] = "HalfHour";
    RecurrenceMinutes["OneHour"] = "OneHour";
    RecurrenceMinutes["TwoHour"] = "TwoHour";
    RecurrenceMinutes["FourHour"] = "FourHour";
    RecurrenceMinutes["SixHour"] = "SixHour";
    RecurrenceMinutes["EightHour"] = "EightHour";
    RecurrenceMinutes["TwelveHour"] = "TwelveHour";
    RecurrenceMinutes["OneDay"] = "OneDay";
})(RecurrenceMinutes = exports.RecurrenceMinutes || (exports.RecurrenceMinutes = {}));
;
exports.RecurrenceMinutesToNumberMap = {
    FifteenMinutes: exports.FIFTEEN_MINUTES,
    HalfHour: exports.HALF_HOUR,
    OneHour: exports.MINUTES_IN_HOUR,
    TwoHour: exports.TWO_HOURS,
    FourHour: exports.FOUR_HOURS,
    SixHour: exports.SIX_HOURS,
    EightHour: exports.EIGHT_HOURS,
    TwelveHour: exports.TWELVE_HOURS,
    OneDay: exports.ONE_DAY
};
// TODO: Once upgraded to Typescript > 4, can be replaced using an inverter function defined like in https://stackoverflow.com/a/64127710
exports.NumberToRecurrencesMinutesMap = (_a = {},
    _a[exports.FIFTEEN_MINUTES] = RecurrenceMinutes.FifteenMinutes,
    _a[exports.HALF_HOUR] = RecurrenceMinutes.HalfHour,
    _a[exports.MINUTES_IN_HOUR] = RecurrenceMinutes.OneHour,
    _a[exports.TWO_HOURS] = RecurrenceMinutes.TwoHour,
    _a[exports.FOUR_HOURS] = RecurrenceMinutes.FourHour,
    _a[exports.SIX_HOURS] = RecurrenceMinutes.SixHour,
    _a[exports.EIGHT_HOURS] = RecurrenceMinutes.EightHour,
    _a[exports.TWELVE_HOURS] = RecurrenceMinutes.TwelveHour,
    _a[exports.ONE_DAY] = RecurrenceMinutes.OneDay,
    _a);
var RecurrenceDaysOfTheWeek;
(function (RecurrenceDaysOfTheWeek) {
    RecurrenceDaysOfTheWeek["Sun"] = "Sun";
    RecurrenceDaysOfTheWeek["Mon"] = "Mon";
    RecurrenceDaysOfTheWeek["Tue"] = "Tue";
    RecurrenceDaysOfTheWeek["Wed"] = "Wed";
    RecurrenceDaysOfTheWeek["Thu"] = "Thu";
    RecurrenceDaysOfTheWeek["Fri"] = "Fri";
    RecurrenceDaysOfTheWeek["Sat"] = "Sat";
})(RecurrenceDaysOfTheWeek = exports.RecurrenceDaysOfTheWeek || (exports.RecurrenceDaysOfTheWeek = {}));
;
var RecurrenceConverters = /** @class */ (function () {
    function RecurrenceConverters() {
    }
    /* tslint:disable:no-bitwise */
    /**
     * Converts from the 32 bit integer into a array of day numbers.
     * @param recurrenceDayOfMonth - 32 integer in decimal string form
     * @return array of day numbers. e.g. integer 7 would have it's first, second and third bits set to 1
     * That would yield ("7") => [1,2,3]. See unit tests for more examples.
     * */
    RecurrenceConverters.toDaysOfMonthArr = function (recurrenceDayOfMonth) {
        if (recurrenceDayOfMonth === undefined || recurrenceDayOfMonth === null || recurrenceDayOfMonth === '') {
            return [];
        }
        var daysOfMonthMask = parseInt(recurrenceDayOfMonth, 10);
        if (isNaN(daysOfMonthMask)) {
            throw recurrenceDayOfMonth + ' is an invalid daysOfMonthMask';
        }
        var resultDaysOfMothArr = [];
        // special case of Last
        if (daysOfMonthMask === 0) {
            resultDaysOfMothArr.push(0);
        }
        var dayNum = 1;
        while (daysOfMonthMask > 0) {
            if (daysOfMonthMask & 1) {
                resultDaysOfMothArr.push(dayNum);
            }
            dayNum++;
            daysOfMonthMask = daysOfMonthMask >>> 1;
        }
        return resultDaysOfMothArr;
    };
    /**
     * Converts an array of day numbers into a 32 bit integer mask.
     * @param daysOfMonth - array of day numbers from 1 to 31.
     * @return 32 bit integer mask. e.g. integer 7 would have it's first, second and third bits set to 1
     * That would yield ([1,2,3]) => 7. See unit tests for more examples.
     * */
    RecurrenceConverters.toDaysOfMonthMask = function (daysOfMonth) {
        if (!daysOfMonth) {
            throw 'daysOfMonth should be non-null/non-undefined (truthy)';
        }
        if (daysOfMonth.length === 0) {
            throw "daysOfMonth should be non-empty: " + daysOfMonth;
        }
        var daysOfMonthMask = 0;
        // special case
        if (daysOfMonth.indexOf(0) >= 0) {
            return 0;
        }
        for (var i = 0; i < daysOfMonth.length; i++) {
            daysOfMonthMask |= RecurrenceConverters.getDayOfMonthMask(daysOfMonth[i]);
        }
        return daysOfMonthMask;
    };
    RecurrenceConverters.getDayOfMonthMask = function (dayOfMonth) {
        if (dayOfMonth > 31 || dayOfMonth === undefined) {
            throw 'Invalid day in a month:' + dayOfMonth;
        }
        var dayOfMonthMask = 1;
        if (dayOfMonth > 1) {
            dayOfMonthMask = dayOfMonthMask << (dayOfMonth - 1);
        }
        return dayOfMonthMask;
    };
    /* tslint:enable:no-bitwise */
    RecurrenceConverters.getDayOfWeek = function (day) {
        var dayNum = day.getDay();
        switch (dayNum) {
            case 0:
                return [RecurrenceDaysOfTheWeek.Sun];
            case 1:
                return [RecurrenceDaysOfTheWeek.Mon];
            case 2:
                return [RecurrenceDaysOfTheWeek.Tue];
            case 3:
                return [RecurrenceDaysOfTheWeek.Wed];
            case 4:
                return [RecurrenceDaysOfTheWeek.Thu];
            case 5:
                return [RecurrenceDaysOfTheWeek.Fri];
            case 6:
                return [RecurrenceDaysOfTheWeek.Sat];
            default:
                return [];
        }
    };
    RecurrenceConverters.recurrenceDayToDescriptionString = function (recurrenceDayOfMonth) {
        switch (recurrenceDayOfMonth) {
            case 1:
                return Localize_1.Messages.RecurrenceMonthlyOnFirst();
            case 2:
                return Localize_1.Messages.RecurrenceMonthlyOnSecond();
            case 3:
                return Localize_1.Messages.RecurrenceMonthlyOnThird();
            case 4:
                return Localize_1.Messages.RecurrenceMonthlyOnFourth();
            case 5:
                return Localize_1.Messages.RecurrenceMonthlyOnFifth();
            case 0:
                return Localize_1.Messages.RecurrenceMonthlyOnLast();
            default:
                return Localize_1.Messages.RecurrenceOnDay();
        }
    };
    // This is supposedly not the "optimal" cloning method
    // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
    // But even though there are tests to ensure it works as expected, the Object.assign approach doesn't seem to work
    RecurrenceConverters.clone = function (x) {
        return JSON.parse(JSON.stringify(x));
    };
    RecurrenceConverters.castScheduleToRecurrence = function (originalSchedule) {
        // Cloned to ensure the original object is not modified
        var schedule = RecurrenceConverters.clone(originalSchedule);
        var isNotNullOrUndefined = function (x) { return x !== null && x !== undefined; };
        var recurrence = {
            // tslint:disable-next-line: no-any
            recurrenceDetails: schedule.scheduleDetails,
            recurrenceMode: RecurrenceMode.TimeRecurrence,
            recurrenceType: schedule.scheduleType,
        };
        var daysOfWeekDefined = isNotNullOrUndefined(recurrence.recurrenceDetails.recurrenceDaysOfWeek);
        switch (recurrence.recurrenceType) {
            case RecurrenceType.Hourly:
                // SSS expects both Hourly and Daily schedules to have recurrenceDaysOfWeek to be set. In the Admin Schedules these schedule
                // types did not have those values set, and that was interpretted to mean "every day of the week"
                if (!daysOfWeekDefined || recurrence.recurrenceDetails.recurrenceDaysOfWeek.length === 0) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                break;
            case RecurrenceType.Daily:
                var dailyRecurrence = recurrence.recurrenceDetails;
                // SSS expects both Hourly and Daily schedules to have recurrenceDaysOfWeek to be set. In the Admin Schedules these schedule
                // types did not have those values set, and that was interpretted to mean "every day of the week"
                if (!daysOfWeekDefined || dailyRecurrence.recurrenceDaysOfWeek.length === 0) {
                    dailyRecurrence.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                // SSS expects end time to equal start time if the schedule runs "all day"
                var endTimeDefined = isNotNullOrUndefined(recurrence.recurrenceDetails.endTime);
                if (!endTimeDefined) { // ends when it starts...
                    dailyRecurrence.endTime = dailyRecurrence.startTime;
                }
                // SSS expects recurrence minutes to be the number of minutes in a day if the schedule runs on a 24 hour recurrence (daily)
                var recurrenceMinutesDefined = isNotNullOrUndefined(recurrence.recurrenceDetails.recurrenceMinutes);
                if (!recurrenceMinutesDefined) {
                    dailyRecurrence.recurrenceMinutes = StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY;
                }
                // SSS does not allow recurrence minutes to be less than 2 hours for daily. If it is it's a legacy schedule
                if (recurrence.recurrenceDetails.recurrenceMinutes < 60 * 2) {
                    dailyRecurrence.recurrenceMinutes = StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY;
                }
                // SSS expects "all day" schedules to start when they end
                if (dailyRecurrence.recurrenceMinutes === StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY) {
                    dailyRecurrence.endTime = dailyRecurrence.startTime;
                }
                break;
            case RecurrenceType.Weekly:
                if (!daysOfWeekDefined || recurrence.recurrenceDetails.recurrenceDaysOfWeek.length === 0) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                break;
            case RecurrenceType.Monthly:
                if (!daysOfWeekDefined) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = [];
                }
                break;
            default:
            // Do nothing
        }
        return recurrence;
    };
    RecurrenceConverters.convertLegacyScheduleToRecurrence = function (originalSchedule) {
        // Same process as casting a non legacy BUT we also need to turn days of month into the bitmask representation
        var recurrence = RecurrenceConverters.castScheduleToRecurrence(originalSchedule);
        if (recurrence.recurrenceType === RecurrenceType.Monthly) {
            var isLastDayOfMonth = recurrence.recurrenceDetails.recurrenceDayOfMonth === 'Last';
            if (isLastDayOfMonth) {
                recurrence.recurrenceDetails.recurrenceDayOfMonth = '0';
            }
            else {
                var dayOfMonth = Number(recurrence.recurrenceDetails.recurrenceDayOfMonth);
                recurrence.recurrenceDetails.recurrenceDayOfMonth = String(RecurrenceConverters.toDaysOfMonthMask([dayOfMonth]));
            }
        }
        return recurrence;
    };
    RecurrenceConverters.convertRecurrenceToLegacySchedule = function (originalRecurrence, serverOffsetMinutes) {
        // This function modifies key attributes and as such needs to make a copy of the data to avoid any unexpected side-effects
        var recurrence = RecurrenceConverters.clone(originalRecurrence);
        var isNotNullOrUndefined = function (x) { return x !== null && x !== undefined; };
        // Method must be resilient to malformed recurrences
        var daysOfWeekDefined = isNotNullOrUndefined(recurrence.recurrenceDetails.recurrenceDaysOfWeek);
        var isAllDaysOfTheWeek = daysOfWeekDefined && recurrence.recurrenceDetails.recurrenceDaysOfWeek.length === 7;
        switch (recurrence.recurrenceType) {
            case RecurrenceType.Hourly:
                if (isAllDaysOfTheWeek) {
                    delete recurrence.recurrenceDetails.recurrenceDaysOfWeek;
                }
                break;
            case RecurrenceType.Daily:
                if (isAllDaysOfTheWeek) {
                    delete recurrence.recurrenceDetails.recurrenceDaysOfWeek;
                }
                var hasRecurrenceMinutes = isNotNullOrUndefined(recurrence.recurrenceDetails.recurrenceMinutes);
                var hasMalformedMinutes = hasRecurrenceMinutes && recurrence.recurrenceDetails.recurrenceMinutes < exports.TWO_HOURS;
                if (hasMalformedMinutes) {
                    recurrence.recurrenceDetails.recurrenceMinutes = exports.ONE_DAY;
                }
                // Schedules created by scripts can have nonsensical end times - endTime should not matter for Daily schedules
                // also legacy schedules simply do not specify the recurrence minutes when it's all day.
                var isTwentyFourRecurrence = recurrence.recurrenceDetails.recurrenceMinutes === exports.ONE_DAY;
                if (isTwentyFourRecurrence || !hasRecurrenceMinutes) {
                    delete recurrence.recurrenceDetails.endTime;
                    delete recurrence.recurrenceDetails.recurrenceMinutes;
                }
                break;
            case RecurrenceType.Weekly:
                // Do nothing
                break;
            case RecurrenceType.Monthly:
                // Nth Day Monthly recurrences can only have 1 day of week
                if (daysOfWeekDefined && recurrence.recurrenceDetails.recurrenceDaysOfWeek.length !== 0) {
                    throw 'Failed to convert schedule: cannot convert Monthly schedule with days of week set';
                }
                // Legacy schedules straight up don't have this field
                if (daysOfWeekDefined) {
                    delete recurrence.recurrenceDetails.recurrenceDaysOfWeek;
                }
                // Schedules (not Recurrences) allow a maximum of 1 day of month
                var daysOfMonthMask = recurrence.recurrenceDetails.recurrenceDayOfMonth;
                var daysOfMonth = RecurrenceConverters.toDaysOfMonthArr(daysOfMonthMask);
                if (daysOfMonth.length !== 1) {
                    throw "Failed to convert schedule: multiple days of month present (" + daysOfMonthMask + " => " + JSON.stringify(daysOfMonth) + ")";
                }
                recurrence.recurrenceDetails.recurrenceDayOfMonth = String(daysOfMonth[0]);
                var isLastDayOfMonth = recurrence.recurrenceDetails.recurrenceDayOfMonth === '0';
                if (isLastDayOfMonth) {
                    recurrence.recurrenceDetails.recurrenceDayOfMonth = 'Last';
                }
                break;
            default:
                throw "Failed to convert recurrence to schedule due to unknown recurrence type: " + JSON.stringify(recurrence);
        }
        return {
            scheduleDetails: recurrence.recurrenceDetails,
            scheduleType: recurrence.recurrenceType,
            serverTimezoneOffset: serverOffsetMinutes || 0,
        };
    };
    return RecurrenceConverters;
}());
exports.RecurrenceConverters = RecurrenceConverters;
function localizeRecurrenceMinutes(recurrenceMinutes) {
    switch (recurrenceMinutes) {
        case RecurrenceMinutes.FifteenMinutes:
            return Localize_1.Messages.RecurrenceMinutesFifteenMinutes();
        case RecurrenceMinutes.HalfHour:
            return Localize_1.Messages.RecurrenceMinutesHalfHour();
        case RecurrenceMinutes.OneHour:
            return Localize_1.Messages.RecurrenceMinutesHour();
        case RecurrenceMinutes.TwoHour:
            return Localize_1.Messages.RecurrenceMinutesTwoHour();
        case RecurrenceMinutes.FourHour:
            return Localize_1.Messages.RecurrenceMinutesFourHour();
        case RecurrenceMinutes.SixHour:
            return Localize_1.Messages.RecurrenceMinutesSixHour();
        case RecurrenceMinutes.EightHour:
            return Localize_1.Messages.RecurrenceMinutesEightHour();
        case RecurrenceMinutes.TwelveHour:
            return Localize_1.Messages.RecurrenceMinutesTwelveHour();
        case RecurrenceMinutes.OneDay:
            return Localize_1.Messages.RecurrenceOnDay();
        default:
            // Technically should be impossible to get here
            throw 'Hourly recurrence not supported for ' + recurrenceMinutes;
    }
}
exports.localizeRecurrenceMinutes = localizeRecurrenceMinutes;
function getHourlyMinutesIntervalsForPaneType(type) {
    switch (type) {
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminLegacySchedule:
            return [
                RecurrenceMinutes.FifteenMinutes,
                RecurrenceMinutes.HalfHour,
                RecurrenceMinutes.OneHour,
                RecurrenceMinutes.TwoHour,
                RecurrenceMinutes.FourHour,
                RecurrenceMinutes.SixHour,
                RecurrenceMinutes.EightHour,
                RecurrenceMinutes.TwelveHour,
            ];
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule:
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh:
            return [
                RecurrenceMinutes.FifteenMinutes,
                RecurrenceMinutes.HalfHour,
                RecurrenceMinutes.OneHour,
            ];
        default:
            return [RecurrenceMinutes.OneHour];
    }
}
exports.getHourlyMinutesIntervalsForPaneType = getHourlyMinutesIntervalsForPaneType;
function getDailyMinutesIntervalsForPaneType(type) {
    switch (type) {
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminLegacySchedule:
            return [RecurrenceMinutes.OneDay];
        default:
            return [
                RecurrenceMinutes.TwoHour,
                RecurrenceMinutes.FourHour,
                RecurrenceMinutes.SixHour,
                RecurrenceMinutes.EightHour,
                RecurrenceMinutes.TwelveHour,
                RecurrenceMinutes.OneDay
            ];
    }
}
exports.getDailyMinutesIntervalsForPaneType = getDailyMinutesIntervalsForPaneType;
function getStartEndTimeMinuteInterval(type, minutes) {
    switch (type) {
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminLegacySchedule:
            return 15;
        case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule:
            return minutes < exports.RecurrenceMinutesToNumberMap.OneHour
                ? 60
                : 5;
        default:
            return minutes < exports.RecurrenceMinutesToNumberMap.OneHour
                ? 60
                : undefined;
    }
}
exports.getStartEndTimeMinuteInterval = getStartEndTimeMinuteInterval;
function getWeekdayInfos() {
    return [
        {
            weekDayId: RecurrenceDaysOfTheWeek.Sun, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekSundayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekSunday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Mon, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekMondayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekMonday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Tue, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekTuesdayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekTuesday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Wed, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekWednesdayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekWednesday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Thu, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekThursdayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekThursday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Fri, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekFridayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekFriday()
        },
        {
            weekDayId: RecurrenceDaysOfTheWeek.Sat, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekSaturdayShort(),
            weekDayAriaLabel: Localize_1.Messages.RecurrenceDayOfWeekSaturday()
        }
    ];
}
exports.getWeekdayInfos = getWeekdayInfos;
function getDayOfMonthOptions() {
    var numDayOptions = StaticInitializers_1.StaticInitializers.MAX_DAYS_IN_A_MONTH + 1;
    var dayOptions = new Array(numDayOptions);
    for (var i = 0; i < StaticInitializers_1.StaticInitializers.MAX_DAYS_IN_A_MONTH; i++) {
        var dayId = i + 1;
        var dayStr = String(dayId);
        dayOptions[i] = { id: dayId, caption: dayStr };
    }
    dayOptions[StaticInitializers_1.StaticInitializers.MAX_DAYS_IN_A_MONTH] = {
        id: MonthlyRecurrencePane_1.DayTypeChoice.Last, caption: Localize_1.Messages.RecurrenceMonthlyOnLast()
    };
    return dayOptions;
}
exports.getDayOfMonthOptions = getDayOfMonthOptions;
//# sourceMappingURL=Recurrence.js.map